// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ScaleWrapper_wrapper__2za8c"};